import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Alerts from "./pages/Alerts";
import Sidebar from "./components/Sidebar/Sidebar";
import Topbar from "./components/Topbar/Topbar";
import Dashboard from "./pages/Dashboard";
import MapPage from "./pages/Map";
import { ThemeProvider } from "./context/ThemeContext";
import { useSocketData } from "./hooks/useSocketData";
import { useState } from "react";
import Settings from "./pages/Settings";
import Devices from "./pages/Devices";
import Home from "./pages/Home";
import Footer from "./pages/Footer";
import Reports from "./pages/Reports";
import Room from "./pages/Room";

function App() {
  const data = useSocketData();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <ThemeProvider>
      <Router>
        <div className="flex min-h-screen overflow-x-auto">
          {/* Sidebar */}
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

          {/* Main Content */}
          <div className="flex-1 flex flex-col">
            <Topbar alerts={data.alerts} toggleSidebar={toggleSidebar} />
            <div className="p-6 flex-1">
              <Routes>
                <Route path="/reports" element={<Reports alerts={data.alerts} />}/>
                <Route path="/devices" element={<Devices devices={data.devices} />} />
                <Route path="/devices/:id" element={<Dashboard devices={data.devices} alerts={data.alerts} />} />
                <Route path="/room/:name" element={<Room />} />
                <Route path="/map" element={<MapPage devices={data.devices} />} />
                <Route path="/alerts" element={<Alerts alerts={data.alerts} devices={data.devices} />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/" element={<Home alerts={data.alerts} devices={data.devices} />} />
              </Routes>
            </div>
            <Footer  />
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
